var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }